import { render, staticRenderFns } from "./productAddEdit.vue?vue&type=template&id=070ba397&scoped=true"
import script from "./productAddEdit.vue?vue&type=script&lang=js"
export * from "./productAddEdit.vue?vue&type=script&lang=js"
import style0 from "./productAddEdit.vue?vue&type=style&index=0&id=070ba397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ba397",
  null
  
)

export default component.exports